import { css } from 'emotion'

const yellow = '#FFCB15'
const green = '#34BFA3'
const red = '#F35670'

// remainingDays
const remainingDaysColorChanger = value => {
  if (value === 0) {
    return green
  }
  if (value <= 0.25) {
    return red
  }

  if (value <= 0.5) {
    return yellow
  }

  return green
}

export const remainingDaysStyle = (data, bpLength) => {
  const color = remainingDaysColorChanger(data / bpLength)
  return css`
    color: ${color};
  `
}

// remainingBudget
const remainingBudgetColorChanger = data => {
  if (!data) {
    return null
  }
  const { remainingBudget, ioLifetimeBudget } = data

  const value = remainingBudget / ioLifetimeBudget
  if (value > 0.5) {
    return red
  }
  if (value > 0.3) {
    return yellow
  }

  return green
}

export const remainingBudgetStyle = data => {
  const color = remainingBudgetColorChanger(data)
  return css`
    color: ${color};
  `
}

export const baseStyle = {
  wrapper: css`
    min-width: 200px;
    margin: 0 0 30px 10px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
      0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
    padding: 15px 20px;
  `,
  basicTitle: css`
    font-size: 16px;
    font-weight: normal;
  `,
  variable: css`
    text-align: center;
    color: ${green};
  `,
  bigNumber: css`
    font-size: 30px;
  `,
  unit: css`
    font-size: 18px;
  `,
}
